@import '../../../../../constants/spacing.module.less';

.modal-row {
  display: flex;
  align-items: stretch;
  height: 696px;
  min-height: min-content;
  flex-flow: row nowrap;
}

.description-section {
  flex: 1 0 384px;
  justify-content: space-between;
}

.description {
  gap: @space-16;
  padding: @space-32;
}

.footer {
  place-self: flex-end flex-end;
  width: 100%;

  border-top: 1px solid var(--gray-DFE4E8);
  background: var(--white);
  box-shadow: 0 -4px 8px -2px rgba(0, 0, 0, 0.08);

  align-items: center;
  justify-content: center;
  padding: @space-24 @space-32;

  .offer-button {
    font-size: 14px;
  }
}

.offer-button {
  width: 100%;
  height: 100%;
  padding: @space-12;
}

.image-section {
  background-color: var(--purple-F6F2FF);
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;

  > img {
    max-width: 100%;
  }
  flex: 1 0 624px;
}
